module.exports = __webpack_public_path__ + "media/assets/images/claim-places/home-de3a448aff23c2e1ddab2ea419d1e210.svg";